export default __webpack_public_path__ + "static/invoiceCardRight-031a0f25fff7dc70b833bed812087e06.png";